"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _xcrud = _interopRequireDefault(require("xcrud"));
var _config = _interopRequireDefault(require("xcrud/package/common/config"));
var _showConfig2 = _interopRequireDefault(require("../config/showConfig"));
_config.default.set({
  input: {
    // size: 'mini'
  },
  select: {
    // size: 'mini'
  },
  colorPicker: {
    showAlpha: true
  },
  xform: {
    form: {
      labelWidth: 'auto'
      // size: 'mini'
    }
  }
});
var _default2 = exports.default = {
  components: {
    xForm: _xcrud.default.xForm
  },
  props: {
    modeler: {
      type: Object,
      required: true
    },
    element: {
      type: Object,
      required: true
    },
    categorys: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    'formData.id': function formDataId(val) {
      this.updateProperties({
        id: val
      });
    },
    'formData.name': function formDataName(val) {
      this.updateProperties({
        name: val
      });
    },
    'formData.documentation': function formDataDocumentation(val) {
      if (!val) {
        this.updateProperties({
          documentation: []
        });
        return;
      }
      var documentationElement = this.modeler.get('moddle').create('bpmn:Documentation', {
        text: val
      });
      this.updateProperties({
        documentation: [documentationElement]
      });
    }
  },
  methods: {
    updateProperties: function updateProperties(properties) {
      var modeling = this.modeler.get('modeling');
      modeling.updateProperties(this.element, properties);
    }
  },
  computed: {
    elementType: function elementType() {
      var bizObj = this.element.businessObject;
      return bizObj.eventDefinitions ? bizObj.eventDefinitions[0].$type : bizObj.$type;
    },
    showConfig: function showConfig() {
      return _showConfig2.default[this.elementType] || {};
    }
  }
};